import { createRequestTypes } from '../../utils';

export const LOAD_FORM = createRequestTypes('draftLabelForm/LOAD_FORM');
